import { LoadableAfterPaint, type LoadableType } from '@confluence/loadable';

import type { ObjectSidebarPanelWrapperProps } from '../src/ObjectSidebarPanelWrapper';

export const ObjectSidebarPanel: LoadableType<ObjectSidebarPanelWrapperProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectSidebarPanel" */ '../src/ObjectSidebarPanelWrapper'
			)
		).ObjectSidebarPanelWrapper,
});
